import { inject, Pipe, PipeTransform } from '@angular/core';
import { ExchangeRatesService } from '../core/exchange-rates.service.js';
import { CurrencyId } from '@gains-com/shared';

@Pipe({
  name: 'currencyConvert',
})
export class CurrencyConvertPipe implements PipeTransform {
  private _rates = inject(ExchangeRatesService);

  async transform(
    value: string | number,
    _baseCurrencyId: CurrencyId | keyof typeof CurrencyId,
    _targetCurrencyId: CurrencyId | keyof typeof CurrencyId
  ): Promise<number> {
    const baseCurrencyId = Object.values(CurrencyId).includes(
      _baseCurrencyId as CurrencyId
    )
      ? (_baseCurrencyId as CurrencyId)
      : CurrencyId[_baseCurrencyId as keyof typeof CurrencyId];
    const targetCurrencyId = Object.values(CurrencyId).includes(
      _targetCurrencyId as CurrencyId
    )
      ? (_targetCurrencyId as CurrencyId)
      : CurrencyId[_targetCurrencyId as keyof typeof CurrencyId];

    return await this._rates.convertCurrency(
      value,
      baseCurrencyId,
      targetCurrencyId
    );
  }
}
